import { Link } from 'react-router-dom'
import { Calendar, MapPin, Users, ArrowRight } from 'lucide-react'
import { getMediaUrl } from '../utils/media'

const CarteProgram = ({ program }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 flex flex-col h-full">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={getMediaUrl(program.image_couverture, 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800')} 
          alt={program.titre}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800';
          }}
        />
        <div className="absolute top-4 left-4">
          <span className="bg-cidh-green text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
            {program.categorie}
          </span>
        </div>
      </div>
      
      <div className="p-6 flex-grow flex flex-col">
        <h3 className="text-xl font-bold mb-3 text-cidh-blue line-clamp-2 leading-tight">
          {program.titre}
        </h3>
        <p className="text-gray-500 text-sm mb-6 line-clamp-3">
          {program.description_courte}
        </p>
        
        <div className="mt-auto space-y-2 mb-6">
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Calendar size={14} className="text-cidh-gold" />
            <span>Début: {new Date(program.date_debut).toLocaleDateString('fr-FR')}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <MapPin size={14} className="text-cidh-gold" />
            <span>{program.lieu}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Users size={14} className="text-cidh-gold" />
            <span>{program.beneficiaires} bénéficiaires</span>
          </div>
        </div>
        
        <Link 
          to={`/programmes/${program.slug}`} 
          className="w-full text-center py-2 border border-cidh-blue text-cidh-blue font-semibold rounded-md hover:bg-cidh-blue hover:text-white transition-all flex items-center justify-center gap-2"
        >
          Voir le programme <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  )
}

export default CarteProgram
